// SPDX-License-Identifier: MIT
// Build the instruction handed to the desktop streaming agent ("Claude construit
// ton projet"). The base task says nothing about a backend, so the user's generic
// Claude improvised "create a Supabase account" whenever the project needed
// persistence (Bug D, 2026-06-06). This appends a backend-aware clause:
//   - creds present (BYO or Genesis-provisioned) → USE them, never tell the user to
//     sign up for a third-party service ;
//   - no creds → DON'T steer the user to a manual third-party signup; prototype on
//     local storage and surface that managed hosting comes from Genesis (Cloud),
//     not a hand-rolled Supabase account.
// It also appends an IDENTITY clause (2026-06-06): the agent is the user's own Claude
// Code with all its ambient memory, so when a project needed an admin account it
// invented one — reusing a credential it had seen from ANOTHER project. Passing the
// user's Genesis email makes "admin = your email" the default and forbids reusing any
// credential found elsewhere on the machine / in memory.
// Pure + i18n-injected (t) so it unit-tests without the DOM.
import type { ProjectRow } from '../projects/api';

type Translate = (key: string) => string;

export function buildAgentBuildTask(
  row: Pick<ProjectRow, 'backend_url' | 'backend_anon_key'>,
  t: Translate,
  userEmail?: string | null,
): string {
  const hasBackend = !!(row.backend_url && row.backend_anon_key);
  const backendClause = t(hasBackend ? 'delivery.agentBackendConfigured' : 'delivery.agentBackendNone');
  const identityClause = userEmail
    ? ' ' + t('delivery.agentIdentity').replace('{email}', userEmail)
    : '';
  return `${t('delivery.agentBuildTask')} ${backendClause}${identityClause}`;
}
